import { Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { useDisclosure } from "@heroui/react";
import { FaHeadset } from "react-icons/fa6";

interface TicketTypeSelectionModalProps {
  disclosure: ReturnType<typeof useDisclosure>;
  onSelectType: (type: "user_to_landlord" | "to_platform" | "cancel") => void;
}

export function TicketTypeSelectionModal({
  disclosure,
  onSelectType,
}: TicketTypeSelectionModalProps) {
  const { isOpen, onOpenChange } = disclosure;

  const handleSelectType = (
    type: "user_to_landlord" | "to_platform" | "cancel",
  ) => {
    onSelectType(type);
    disclosure.onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      onClose={() => handleSelectType("cancel")}
    >
      <ModalContent>
        <ModalHeader>Выберите тип тикета</ModalHeader>
        <ModalBody className="pb-6">
          <div className="flex flex-col gap-2">
            <div className="text-sm text-foreground-500">
              Выберите, к кому вы хотите обратиться с вашим вопросом или
              проблемой
            </div>

            <div className="grid grid-cols-1 gap-2">
              {/* <div
                className="h-fit flex flex-col gap-2 p-4 border-2 border-foreground-300 rounded-xl cursor-pointer items-center justify-center"
                onClick={() => handleSelectType("user_to_landlord")}
              >
                <FaBuilding className="text-2xl text-primary" />
                <div className="flex flex-col items-center">
                  <span className="font-medium">К арендатору</span>
                  <span className="text-xs text-foreground-500 text-center">Вопросы по коворкингу и его работе</span>
                </div>
              </div> */}

              <div
                className="h-fit flex flex-col gap-2 p-4 border-2 border-foreground-300 rounded-xl cursor-pointer items-center justify-center"
                onClick={() => handleSelectType("to_platform")}
              >
                <FaHeadset className="text-2xl text-primary" />
                <div className="flex flex-col items-center">
                  <span className="font-medium">К платформе</span>
                  <span className="text-xs text-foreground-500 text-center">
                    Поддержка платформы, предложения
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
